<template>
	<div>
		<div class="page-content">
			<div class="inner-content">
		
				<div class="main-title">
					<p class="title faded_red_text"><span class="no faded_red_bg">{{ calc_index + 1 }}</span>Localisation du projet</p>
					<p class="subtitle">Attractivité résidentielle, localisation et commercialité sur le marché locatif à la mise en location</p>
				</div>
				<section-localisation main_color="faded_red" />
				<div class="main-title">
					<p class="title green_text"><span class="no green_bg">{{ calc_index + 2 }}</span> Dynamique territoriale</p>
				</div>
				<section-dynamique-territoriale main_color="green" />
			</div>
		</div>
	</div>
</template>

<script>

import SectionLocalisation from "@/components/study/editor/pages/sections/section-localisation";
import SectionDynamiqueTerritoriale from "@/components/study/editor/pages/sections/section-dynamique-territoriale";

import PageMixin from "@/components/study/editor/pages/page.mixin.js";

export default {
	name: "page-territoire",
	mixins: [ PageMixin ],
	data: function () {
		return {
			
		};
	},
	props: [ "index" ],
	computed: {
		calc_index: function () {
			if(this.active_study.etudeType.slug == "grand_projet")
				return this.index + 1;
			return this.index;
		}
	},
	components: {
		SectionLocalisation,
		SectionDynamiqueTerritoriale,
	},
};
</script>

<style lang="stylus" scoped>
@import '../../../../assets/css/app'
@import '../../../../assets/css/page'

.map_img
	height 200px

</style>